export const debug = {
  "phaser-bodies": false,
};
